import { useRecoilValue } from 'recoil'
import { userAtom } from '../atoms/userAtom'

export const useUser = () => {
  const user = useRecoilValue(userAtom)

  return user
}
